import { Status } from './status.model';
import { Company } from './company.model';
import { StoryContact } from './story-contact.model';
import { StoryLink } from './story-link.model';
import { StorySubject } from './story-subject.model';
import { BodyContentsModel } from './body-content-model';
import { Injectable } from '@angular/core';

@Injectable()
export class UnifiedStoryResponseModel {
    id: number;
    accountId: number;
    createdUserId: number;
    createdDate: number;
    modifiedUserId: number;
    modifiedDate?: any;
    deletedUserId: number;
    deletedDate?: any;
    name?: string;
    headline?: string;
    body?: string;
    author?: string;
    publishedDate?: number;
    timeZone?: string;
    aboutUs?: string;
    status?: Status;
    links?: StoryLink[];
    imageData?: string;
    imageId?: string;
    company?: Company;
    subjects?: StorySubject[];
    contacts?: StoryContact[];
    storySlug?: string;
    companySlug?: string;
    type?: string;
    statusId?: number;
    bodyContents?: BodyContentsModel[];
    datelineDate?: number;
    datelineLocation?: string;
}
